module.exports = __webpack_public_path__ + "static/media/img__before-after.da7669cc.png";